import { IconButton } from '../primitives/IconButton';
import { Icon, Icons } from '../icons';
import { useColorMode } from '../theme';

export interface ThemeToggleProps {
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Light/dark toggle for the shell. A control-room tool wants a first-class dark mode;
 * this flips it and reads the current mode from the shared color-mode provider.
 */
export function ThemeToggle({ size = 'md' }: ThemeToggleProps) {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';
  return (
    <IconButton
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      data-testid="theme-toggle"
      variant="ghost"
      size={size}
      onClick={toggleColorMode}
      icon={<Icon as={isDark ? Icons.Sun : Icons.Moon} size="md" tone="current" />}
    />
  );
}
